/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckyboxNewRound.vue?vue&type=template&id=9fbfee08&scoped=true"
import script from "./popLuckyboxNewRound.vue?vue&type=script&lang=js"
export * from "./popLuckyboxNewRound.vue?vue&type=script&lang=js"
import style0 from "./popLuckyboxNewRound.vue?vue&type=style&index=0&id=9fbfee08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbfee08",
  null
  
)

export default component.exports